import {
    CLOSE_INDOOR_MAP_EDITOR,
    INDOOR_MAP_EDITOR_CHANGE_ITEM,
    OPEN_INDOOR_MAP_EDITOR,
    OpenIndoorMapEditorAction
} from '../actions/indoorMapEditor';
import { IndoorMapEditorState } from '../typings/displayMap';

export const defaultIndoorMapEditorState: IndoorMapEditorState = {
    isVisible: false,
    groupId: '',
    checkedByRegion: undefined
};

export function indoorMapEditor(
    state: IndoorMapEditorState = defaultIndoorMapEditorState,
    action: OpenIndoorMapEditorAction
): IndoorMapEditorState {
    switch (action.type) {
        case OPEN_INDOOR_MAP_EDITOR: {
            return {
                ...state,
                groupId: action.groupId,
                isVisible: true,
                checkedByRegion: action.checkedByRegion
            };
        }

        case INDOOR_MAP_EDITOR_CHANGE_ITEM: {
            return {
                ...state,
                checkedByRegion: action.checkedByRegion
            };
        }

        case CLOSE_INDOOR_MAP_EDITOR: {
            return {
                ...state,
                isVisible: false,
                checkedByRegion: undefined
            };
        }

        default:
            return state;
    }
}
